import { Placeholder, Table } from '@enterprise-ui/canvas-ui-react'

const TablePlaceholder = () => {
  return (
    <Placeholder>
      <Table name="art for sale" alternateRowColor>
        <Table.Head>
          <Table.Row id="table_header">
            {[...Array(6)].map((x, i) => (
              <Table.Header xs={2} id={`pch_${i}`} key={`pch_key_${i}`}>
                <Placeholder.Text key={`pch_txt_${i}`} />
              </Table.Header>
            ))}
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {[...Array(10)].map((x, i) => (
            <Table.Row id={`pc_${i}`} key={`pc_key_${i}`}>
              {[...Array(6)].map((x, i) => (
                <Table.Data xs={2} key={`pch_td_${i}`}>
                  <Placeholder.Text emphasized key={`pch_text_${i}`} />
                </Table.Data>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Placeholder>
  )
}
export default TablePlaceholder
